export default __webpack_public_path__ + "static/media/wind_speed-active.423726bd.svg";